// Lead Import field names following admin panel conventions
export const leadImportFields = {
  id: 'id',
  batchId: 'batchId',
  filename: 'filename',
  sourceOrg: 'source_org',
  status: 'status',
  triggeredBy: 'uploaderId',
  progressPercentage: 'progress_percentage',
  progressLog: 'progress_log',
  successfulRecords: 'successful_records',
  failedRecords: 'failed_records',
  duplicatedRecords: 'duplicated_records',
  duplicateFromCsv: 'duplicate_from_csv',
  duplicateFromDb: 'duplicate_from_db',
  mergedRecords: 'merged_records',
  stats: 'stats',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startedAt: 'startedAt',
};

// Failure types for detailed reporting
export const failureTypes = {
  MISSING_REQUIRED_FIELDS: 'MISSING_REQUIRED_FIELDS',
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_PHONE: 'INVALID_PHONE',
  TRANSFORMATION_ERROR: 'TRANSFORMATION_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  DATABASE_ERROR: 'DATABASE_ERROR',
  TRANSACTION_FAILED: 'TRANSACTION_FAILED',
};

// Duplicate types for detailed reporting
export const duplicateTypes = {
  INTERNAL_BATCH_DUPLICATE: 'INTERNAL_BATCH_DUPLICATE',
  DATABASE_DUPLICATE: 'DATABASE_DUPLICATE',
};

// Human-readable labels for failure types
export const failureTypeLabels = {
  [failureTypes.MISSING_REQUIRED_FIELDS]: 'Missing Required Fields',
  [failureTypes.INVALID_EMAIL]: 'Invalid Email Format',
  [failureTypes.INVALID_PHONE]: 'Invalid Phone Number',
  [failureTypes.TRANSFORMATION_ERROR]: 'Data Transformation Error',
  [failureTypes.VALIDATION_ERROR]: 'Validation Error',
  [failureTypes.DATABASE_ERROR]: 'Database Error',
  [failureTypes.TRANSACTION_FAILED]: 'Transaction Failed',
};

// Human-readable labels for duplicate types
export const duplicateTypeLabels = {
  [duplicateTypes.INTERNAL_BATCH_DUPLICATE]: 'Duplicate in File',
  [duplicateTypes.DATABASE_DUPLICATE]: 'Already in Database',
};

// Status constants
export const leadImportStatuses = {
  QUEUED: 'QUEUED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  ROLLED_BACK: 'ROLLED_BACK',
  ROLLING_BACK: 'ROLLING_BACK',
  ROLLBACK_FAILED: 'ROLLBACK_FAILED',
};

// Choice arrays for React Admin components
export const leadImportStatusChoices = [
  { id: leadImportStatuses.QUEUED, name: 'Queued' },
  { id: leadImportStatuses.PROCESSING, name: 'Processing' },
  { id: leadImportStatuses.COMPLETED, name: 'Completed' },
  { id: leadImportStatuses.FAILED, name: 'Failed' },
  { id: leadImportStatuses.CANCELLED, name: 'Cancelled' },
  { id: leadImportStatuses.ROLLED_BACK, name: 'Rolled Back' },
  { id: leadImportStatuses.ROLLING_BACK, name: 'Rolling Back' },
  { id: leadImportStatuses.ROLLBACK_FAILED, name: 'Rollback Failed' },
];

export default leadImportFields;
